<template>
  <div
    class="thumb-rating-box sentinel-box"
    tabindex="0"
  >
    <button
      aria-label="thumbs-down"
      class="thumb-down thumb-btn tab-focused-btn"
      :class="{'selected': thumbsDown.selected}"
      :aria-pressed="thumbsDown.selected"
      :disabled="disabled" 
      @click="handleThumbDownClick"
      @mouseover="handleThumbHovered(true, 'down')"
      @mouseleave="handleThumbHovered(false, 'down')"
    >
      <div
        class="ratings"
        :class="{'ratings-btn-disabled': disabled}"
      >
        <BaseIcon
          :name="thumbDownType"
          height="32px"
          width="32px"
          :fill="getFillColor(thumbDownType)"
        />
      </div>
    </button>
    <button
      aria-label="thumbs-up"
      class="thumb-up thumb-btn tab-focused-btn"
      :class="{'selected': thumbsUp.selected}" 
      :aria-pressed="thumbsUp.selected"
      :disabled="disabled"
      @mouseover="handleThumbHovered(true, 'up')"
      @mouseleave="handleThumbHovered(false, 'up')"
      @click="handleThumbUpClick"
    >
      <div
        class="ratings"
        :class="{'ratings-btn-disabled': disabled}"
      >
        <BaseIcon
          :name="thumbUpType"
          height="32px"
          width="32px"
          :fill="getFillColor(thumbUpType)"
        />
      </div>
    </button>
  </div>
</template>
<script>
import BaseIcon from '@/views/BaseIcon.vue';
import { ICONS, COLORS} from '../../constant'

export default {
  name: 'ThumbsRating',
  components: {
    BaseIcon
  },
  props: {
    ratingChanged: {
      type: Function,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      thumbDownType: ICONS.THUMB_DOWN,
      thumbUpType: ICONS.THUMB_UP,
      thumbsUp: {
        hovered: false,
        selected: false
      },
      thumbsDown: {
        hovered: false,
        selected: false
      }
    }
  },
  computed: {
    brandColor() {
      return this.$store.state.widgetConfig?.theme?.color || '#4D39E9'
    }
  },
  watch: {
    schema() {
      this.thumbDownType = ICONS.THUMB_DOWN
      this.thumbUpType = ICONS.THUMB_UP
    }
  },
  methods: {
    handleThumbDownClick() {
      this.thumbDownType = ICONS.THUMB_DOWN_FILLED
      this.thumbUpType = ICONS.THUMB_UP
      this.thumbsDown.selected = true
      this.thumbsUp.selected = false
      this.thumbsDown.hovered = false
      this.ratingChanged(1)
    },
    handleThumbUpClick() {
      this.thumbUpType = ICONS.THUMB_UP_FILLLED
      this.thumbDownType = ICONS.THUMB_DOWN
      this.thumbsDown.selected = false
      this.thumbsUp.selected = true
      this.thumbsUp.hovered = false
      this.ratingChanged(2)
    },
    handleThumbHovered(isHovered, type) {
      if (type === 'up' && !this.thumbsUp.selected) {
        this.thumbsUp.hovered = isHovered;
      } else if (type === 'down' && !this.thumbsDown.selected) {
        this.thumbsDown.hovered = isHovered;
      }
    },
    getFillColor(type) {
      if (type === 'ThumbDown' || type === 'ThumbDownFilled') {
        return  this.thumbsDown.hovered || this.thumbsDown.selected ? this.brandColor : COLORS.THUMB;
      } else if (type === 'ThumbUp' || type === 'ThumbUpFilled') {
        return this.thumbsUp.hovered || this.thumbsUp.selected ? this.brandColor : COLORS.THUMB;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .thumb-rating-box {
    display: flex;
    gap: 14px;

  .thumb-btn {
    background: #fafafa; 
    fill:#6B6D7C;
    border-radius: 8px;
    height: 48px;
    width: 48px;
    .ratings {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      &.ratings-btn-disabled {
        cursor: not-allowed;
      }
    }
    // Hover and selected effect
    &:hover:not(.ratings-btn-disabled):not(.selected) {
      background: #F1EFFE;
      border-radius: 8px;
    }
    &.selected {
        border: 1px solid #CDCDCD;
        background: #FFFFFF; 
        border-radius: 8px;
    }
  }
}
</style>
